import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { SERVICES } from "@/lib/siteData";

export default function Services() {
    return (
        <section
            id="services"
            data-testid="services"
            className="relative py-24 md:py-32 bg-secondary/40"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-8">
                <div className="max-w-2xl mb-14">
                    <div className="flex items-center gap-3 mb-5">
                        <span className="divider-gold" />
                        <span className="uppercase tracking-[0.28em] text-xs text-gold font-medium">
                            Services
                        </span>
                    </div>
                    <h2 className="font-display text-4xl md:text-5xl leading-tight tracking-tight">
                        A studio built for every stage of your build.
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {SERVICES.map((s, i) => {
                        const Icon = Icons[s.icon] || Icons.Building2;
                        return (
                            <motion.div
                                key={s.title}
                                data-testid={`service-card-${i}`}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.5, delay: (i % 3) * 0.06 }}
                                className="group relative p-7 rounded-xl bg-card border hairline hover:border-gold transition-colors"
                            >
                                <div className="h-12 w-12 rounded-lg border hairline grid place-items-center mb-6 group-hover:bg-gold group-hover:border-gold transition-colors">
                                    <Icon className="h-5 w-5 group-hover:text-white transition-colors" />
                                </div>
                                <h3 className="font-display text-xl md:text-2xl mb-2 tracking-tight">
                                    {s.title}
                                </h3>
                                <p className="text-sm text-muted-foreground leading-relaxed">
                                    {s.desc}
                                </p>
                                <div className="absolute top-6 right-6 text-xs text-muted-foreground/70 font-mono">
                                    {String(i + 1).padStart(2, "0")}
                                </div>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
